var A = function A() {};

A.displayName = "A";

var MyClass = function MyClass(state) {};

MyClass._r = [0, [{
  a: A,
  b: String
}]];
MyClass.displayName = "MyClass";